var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _clipPath;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRTeamPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-team-plus",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0c11.038,0 20,8.962 20,20c0,11.038 -8.962,20 -20,20c-11.038,0 -20,-8.962 -20,-20c0,-11.038 8.962,-20 20,-20Zm-3.276,29.573l-0.021,0.031c-0.142,0.201 -0.374,0.33 -0.635,0.33c-0.429,-0 -0.776,-0.348 -0.776,-0.776c-0,-0.168 0.053,-0.323 0.143,-0.45c0,0 0,0 0,0c1.375,-1.933 3.303,-3.395 5.551,-4.164c0.016,-0.006 0.027,-0.02 0.029,-0.036c0.002,-0.017 -0.006,-0.033 -0.02,-0.041c-2.01,-1.242 -3.327,-3.433 -3.327,-5.931c-0,-3.84 3.113,-6.953 6.952,-6.953l0.011,0.001c0.424,0.006 0.767,0.352 0.767,0.778c-0,0.429 -0.349,0.778 -0.778,0.778l-0.032,-0.001c-2.968,0.018 -5.368,2.429 -5.368,5.401c0,2.982 2.418,5.4 5.4,5.4c0,-0 0,-0 0,-0c2.322,-0.003 4.301,-1.469 5.064,-3.526l0.02,-0.045c0.122,-0.27 0.393,-0.457 0.707,-0.457c0.429,-0 0.777,0.348 0.777,0.776c-0,0.085 -0.014,0.168 -0.04,0.245l-0.01,0.029c-0.547,1.468 -1.575,2.701 -2.893,3.508c-0.015,0.009 -0.022,0.025 -0.021,0.042c0.002,0.016 0.013,0.03 0.029,0.036c2.075,0.721 3.831,1.98 5.138,3.609l0.409,0.51c0.108,0.134 0.172,0.303 0.172,0.487c-0,0.431 -0.354,0.781 -0.79,0.781c-0.269,0 -0.507,-0.134 -0.65,-0.338l-0.351,-0.465c-1.79,-2.229 -4.511,-3.64 -7.561,-3.64c-3.259,-0 -6.142,1.611 -7.896,4.081Zm-0.698,-17.947c-0.059,0 -0.164,-0.018 -0.164,-0.018c-0.489,-0.106 -0.807,-0.134 -1.309,-0.134c-3.004,-0 -5.44,2.436 -5.44,5.44c-0,3.003 2.432,5.437 5.434,5.44c0,0 0,0 0,0c0.419,0 0.758,0.339 0.758,0.758c-0,0.418 -0.339,0.757 -0.758,0.757l-0,-0c-2.854,0.003 -5.422,1.232 -7.216,3.209c-0.001,-0 -0.001,-0 -0.001,0c-0.139,0.158 -0.343,0.258 -0.57,0.258c-0.419,0 -0.759,-0.34 -0.759,-0.759c0,-0.195 0.075,-0.374 0.197,-0.509l0.002,-0.002c1.263,-1.394 2.878,-2.474 4.752,-3.118c0.016,-0.006 0.027,-0.02 0.029,-0.036c0.002,-0.017 -0.006,-0.033 -0.021,-0.042c-2.018,-1.217 -3.367,-3.43 -3.367,-5.959c-0,-3.84 3.113,-6.953 6.953,-6.954l0.007,0c0.637,0.012 1.119,0.05 1.677,0.183l0.008,0.002c0.315,0.092 0.545,0.383 0.545,0.727c-0,0.418 -0.339,0.757 -0.757,0.757Zm11.381,2.358l0.043,0.042c-0.002,0 -0.043,-0.004 -0.043,-0.042l0,-0c0,0.409 0.357,0.741 0.742,0.741c0,0 1.814,0 1.814,0c-0.008,0.605 -0.015,1.21 0,1.814c0.006,0.203 0.073,0.38 0.218,0.524c0.458,0.457 1.267,0.122 1.267,-0.525c-0,0 -0,-1.812 -0,-1.812c0.605,0.008 1.21,0.015 1.815,-0.001c0.203,-0.005 0.379,-0.073 0.524,-0.217c0.458,-0.458 0.123,-1.266 -0.525,-1.266l-1.814,-0c0.008,-0.605 0.015,-1.21 -0,-1.814c-0.005,-0.203 -0.073,-0.379 -0.218,-0.524c-0.458,-0.457 -1.267,-0.122 -1.267,0.525c0,-0 0,1.813 0,1.813c0,-0 -1.814,-0 -1.814,-0c-0.387,-0 -0.742,0.332 -0.742,0.742Zm0.043,0.042c-0.002,-0.002 -0.013,-0.015 -0.023,-0.026c-0.01,-0.012 -0.02,-0.021 -0.02,-0.016l0.043,0.042Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRTeamPlus);
export default __webpack_public_path__ + "static/media/iconR-team-plus.35e747afb9abd067225f99b3b8a6924a.svg";
export { ForwardRef as ReactComponent };